const planEnum = {
  BASIC: 'basic',
  ADVANCE: 'advance',
  PREMIER: 'premier',
  ELITE: 'elite',
  BASIC_PRO: 'basic-pro',
  ADVANCE_PRO: 'advance-pro',
  PREMIUM_PRO: 'premium-pro',
  ELITE_PRO: 'elite-pro',
  ULTRA_CARE: 'ultra-care',
  ELITE_CARE: 'elite-care',
};

export default planEnum;
